<div class="header">
  <h1>Press &amp; Media</h1>
</div>

<div class="main">
  <div class="item">
    <p>Press Kit</p>
    <a angulartics2On="click" angularticsCategory="Download" angularticsEvent="Press Content" [angularticsProperties]="{ label: 'Press Kit' }" href="//assets.goarmyedge.com/Edge/201706/goarmy-edge-press-kit.zip" class="button light">Download ZIP</a>
  </div>

  <div class="item">
    <p>Press Release</p>
    <a angulartics2On="click" angularticsCategory="Download" angularticsEvent="Press Content" [angularticsProperties]="{ label: 'Press Release' }" href="//assets.goarmyedge.com/Edge/201706/goarmy-edge-press-release.pdf" class="button light">Download PDF</a>
  </div>

  <div class="item">
    <p>FAQs</p>
    <a angulartics2On="click" angularticsCategory="Download" angularticsEvent="Press Content" [angularticsProperties]="{ label: 'FAQs' }" href="//assets.goarmyedge.com/Edge/201706/goarmy-edge-faqs-ftbl-and-socr.pdf" class="button light">Download PDF</a>
  </div>

  <div class="item">
    <p>Fact Sheet</p>
    <a angulartics2On="click" angularticsCategory="Download" angularticsEvent="Press Content" [angularticsProperties]="{ label: 'Fact Sheet' }" href="//assets.goarmyedge.com/Edge/201706/goarmy-edge-fact-sheet-ftbl-and-socr.pdf" class="button light">Download PDF</a>
  </div>

  <div class="item">
    <p>Quote Sheet</p>
    <a angulartics2On="click" angularticsCategory="Download" angularticsEvent="Press Content" [angularticsProperties]="{ label: 'Quote Sheet' }" href="//assets.goarmyedge.com/Edge/201706/goarmy-edge-quote-sheet-ftbl-and-socr.pdf" class="button light">Download PDF</a>
  </div>

  <div class="item">
    <p>Promo Video</p>
    <a angulartics2On="click" angularticsCategory="Download" angularticsEvent="Press Content" [angularticsProperties]="{ label: 'Promo Video' }" href="//assets.goarmyedge.com/Edge/201706/goarmy-edge-trailer-ftbl-and-socr.mp4" class="button light">Download MP4</a>
  </div>

  <div class="item">
    <p>App Screenshots</p>
    <a angulartics2On="click" angularticsCategory="Download" angularticsEvent="Press Content" [angularticsProperties]="{ label: 'App Screenshots' }" href="//assets.goarmyedge.com/Edge/201706/goarmy-edge-screenshots.zip" class="button light">Download ZIP</a>
  </div>

  <div class="item">
    <p>Soccer Promo Flyer</p>
    <a angulartics2On="click" angularticsCategory="Download" angularticsEvent="Press Content" [angularticsProperties]="{ label: 'Soccer Promo Flyer' }" href="//assets.goarmyedge.com/Edge/edge-soccer-flyer.pdf" class="button light">Download PDF</a>
  </div>

  <div class="item">
    <p>Football Promo Flyer</p>
    <a angulartics2On="click" angularticsCategory="Download" angularticsEvent="Press Content" [angularticsProperties]="{ label: 'Football Promo Flyer' }" href="//assets.goarmyedge.com/Edge/edge-football-flyer.pdf" class="button light">Download PDF</a>
  </div>

  <!-- <div class="item" *ngIf="!environment.production">
    <p>Fitness Promo Flyer</p>
    <a angulartics2On="click" angularticsCategory="Download" angularticsEvent="Press Content" [angularticsProperties]="{ label: 'Fitness Promo Flyer' }" href="//assets.goarmyedge.com/Edge/edge-football-flyer.pdf" class="button light">Download PDF</a>
  </div> -->
</div>
